import { Link } from "react-router-dom";
import './Menu.css';

export const Menu = ({children}) => {
    return (
        <ul className="Menu">
            {children}
        </ul>
    )
}

export const MenuItem = ({children, path}) => {
    return (
        <li>
            <Link to={path}>{children}</Link>
        </li>
    )
};